import React from 'react';
import Layout from '../../components/Layout';

const Blogpage3 = () => {
  return (
    <Layout>
      <section className="section">
        <div className="content is-medium">
          <h1>Business portrait photography</h1>
          <p>
            Competition is everywhere. It would be an understatement if we were
            to say that the world is reeking with people trying to compete with
            one another. Such is the speed at which we are traveling. Take a
            vacation for a few days and come back to your office – you are
            already not wanted anymore, no matter how important you thought you
            were in the organisation.
          </p>

          <p>
            here is a lot of pressure among those who have just qualified from
            their colleges. Because of the innumerable tools that are available
            to make a resume fancy, these freshers are always on the edge to
            give the best of everything for their resume and that starts with
            the best portrait of themselves. A photograph that captures the
            nerdy yet go-getter attitude in them.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default Blogpage3;
